// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getAuth,
} from "firebase/auth";
import {
  getFirestore,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import {
  getStorage,
} from "firebase/storage";
import { getDatabase } from "firebase/database";

type ENV = 'dev' | 'prod' | 'demo'

export const currentEnv: ENV = "dev";

const env: ENV = currentEnv;

export const Env = env
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC4tt4uCMgtpdchrWIzyeh-O-UHS9uVuck",
  authDomain: "iqranote-928b8.firebaseapp.com",
  projectId: "iqranote-928b8",
  storageBucket: "iqranote-928b8.firebasestorage.app",
  messagingSenderId: "184963309372",
  appId: "1:184963309372:web:7f83f0b0a2f227223ac839",
  measurementId: "G-YQ87YT3KNK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const firestore = getFirestore(app);
export const dbProd = getFirestore(app, "production");
export const dbRecette = getFirestore(app, "recette");
export const database = getDatabase(app);

export const auth = getAuth(app);
export const functions = getFunctions(app);

export const storage = getStorage(app);

function processDB() {
  if (env === "prod") return dbProd;
  return dbRecette;
}

export const db = processDB();